module.exports = __webpack_public_path__ + "img/ride-out.f0298e06.jpg";